module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/btn_hochi_on-1e14b233b586833c2f1954e9c93a56c7.gif";